import React from "react";
import styles from "./CategoryCreatePage.module.css";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import { CategoryForm } from "admin/components/Category";

function CategoryCreatePage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Typography variant="h5" gutterBottom>
          Thêm Sản Phẩm
        </Typography>
      </div>
      <div>
        <CategoryForm />
      </div>
    </div>
  );
}

CategoryCreatePage.propTypes = {};

export default CategoryCreatePage;
